var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.390625C5.81055 0.390625 0.390625 5.81055 0.390625 12.5C0.390625 19.1895 5.81055 24.6094 12.5 24.6094C19.1895 24.6094 24.6094 19.1895 24.6094 12.5C24.6094 5.81055 19.1895 0.390625 12.5 0.390625ZM18.4375 15.6787C18.667 15.9082 18.667 16.2793 18.4375 16.5088L16.5039 18.4375C16.2744 18.667 15.9033 18.667 15.6738 18.4375L12.5 15.2344L9.32129 18.4375C9.0918 18.667 8.7207 18.667 8.49121 18.4375L6.5625 16.5039C6.33301 16.2744 6.33301 15.9033 6.5625 15.6738L9.76562 12.5L6.5625 9.32129C6.33301 9.0918 6.33301 8.7207 6.5625 8.49121L8.49609 6.55762C8.72559 6.32812 9.09668 6.32812 9.32617 6.55762L12.5 9.76562L15.6787 6.5625C15.9082 6.33301 16.2793 6.33301 16.5088 6.5625L18.4424 8.49609C18.6719 8.72559 18.6719 9.09668 18.4424 9.32617L15.2344 12.5L18.4375 15.6787Z",
    fill: "#3E8080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesCircle);
export default __webpack_public_path__ + "static/media/times-circle.d052a2ca369f1fcf8bf6c215f0270653.svg";
export { ForwardRef as ReactComponent };